import {
  CtrlType,
  CtrlProps
} from "@yuigoto/ctrl";

/**
 * @type {CtrlProps[]}
 */
export const GenericNamePhoneControl = [
  {
    name: "name",
    label: "Nome",
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: "Campo obrigatório"
  },
  {
    name: "phone",
    label: "Telefone",
    type: CtrlType.PHONE,
    required: true,
    requiredMessage: "Campo obrigatório"
  }
];
